import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Api from "../Auth/Api";
import { Modal, Toast } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { PDFDownloadLink } from '@react-pdf/renderer';
import GerarPDF from "../Components/GerarPDF";
import { decodeJWT, truncateString } from '../Components/jwtUtils';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import TextareaAutosize from "react-textarea-autosize";
import TableUsuariosProvas from "../Components/TableUsuariosProvas";
import QRCode from 'qrcode.react';
import ModalAvaliacaoReacao from "../Components/ModalAvaliacaoReacao";

function Aulas() {

    const navigate = useNavigate();
    const { id } = useParams();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [dataInfoModulo, setDataInfoModulo] = useState([]);
    const [dataAulas, setDataAulas] = useState([]);
    const [showModalMinhasNotas, setShowModalMinhasNotas] = useState(false);
    const [showModalAtividadeExtra, setShowModalAtividadeExtra] = useState(false);
    const [showModalEditarAula, setShowModalEditarAula] = useState(false);
    const [file0Selected, setFile0Selected] = useState(false);
    const [file1Selected, setFile1Selected] = useState(false);
    const [file2Selected, setFile2Selected] = useState(false);
    const [uploadAulaProgress, setUploadAulaProgress] = useState(0);
    const [showModalDeletar, setShowModalDeletar] = useState(false);
    const [deletarAula, setDeletarAula] = useState([]);
    const [showModalAtribuirNotas, setShowModalAtribuirNotas] = useState(false);
    const [showModalAlunosComNotas, setShowModalAlunosComNotas] = useState(false);
    const [tipoConteudoEditar, setTipoConteudoEditar] = useState('arquivo');
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [filteredUsuarios, setFilteredUsuarios] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [notas, setNotas] = useState({});
    const { register, handleSubmit, control, setValue, reset, formState: { errors } } = useForm();
    const [alternatives, setAlternatives] = useState([]);
    const [selectedQuestao, setSelectedQuestao] = useState(null);
    const [qrCodeData, setQrCodeData] = useState('');
    const [showModalQrCode, setShowModalQrCode] = useState(false);
    const [arquivos, setArquivos] = useState({});
    const [todosArquivosEnviados, setTodosArquivosEnviados] = useState(false);
    const [showModalFinalGrupo, setShowModalFinalGrupo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalTemAvaliacao, setModalTemAvaliacao] = useState(false);
    const [certificadoStatus, setCertificadoStatus] = useState(null);
    const [certificadoChecked, setCertificadoChecked] = useState(false);
    const statusAvaliacao = checkStatusAvaliacao(dataInfoModulo);
    const [avaliacaoReacaoStatus, setAvaliacaoReacaoStatus] = useState(null);
    const [modalTemAvaliacaoReacao, setModalTemAvaliacaoReacao] = useState(false);
    const [modalVerAvaliacaoReacao, setModalVerAvaliacaoReacao] = useState({ show: false, data: null });
    const [avaliacaoReacaoHibridoStatus, setAvaliacaoReacaoHibridoStatus] = useState(null);
    const [modalTemAvaliacaoReacaoHibrido, setModalTemAvaliacaoReacaoHibrido] = useState(false);
    const [reloadQuestoes, setReloadQuestoes] = useState(false);
    const [reloadAvaliacao, setReloadAvaliacao] = useState(false);
    const [showModalDeletarAvaliacao, setShowModalDeletarAvaliacao] = useState(false);
    const [reloadAulas, setReloadAulas] = useState(false);
    const [showModalNovaAula, setShowModalNovaAula] = useState(false);
    const [file0SelectedNova, setFile0SelectedNova] = useState(false);
    const [file1SelectedNova, setFile1SelectedNova] = useState(false);
    const [file2SelectedNova, setFile2SelectedNova] = useState(false);
    const [uploadAulaProgressNova, setUploadAulaProgressNova] = useState(0);
    const [tipoConteudoNova, setTipoConteudoNova] = useState('arquivo');
    const { register: register_Nova, handleSubmit: handleSubmit_Nova, control: control_Nova, setValue: setValue_Nova, reset: reset_Nova, formState: { errors: errors_Nova } } = useForm();

    // Estados para layout responsivo
    const [descricaoExpandida, setDescricaoExpandida] = useState(false);

    // Verificar status da avaliação de reação
    useEffect(() => {
        async function verificarStatusAvaliacaoReacao() {
            if (!dataInfoModulo[0] || nivel === 'Administrador' || nivel === 'Moderador') {
                return;
            }

            try {
                const response = await Api.get(`api/verificar-status-avaliacao-reacao/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAvaliacaoReacaoStatus(response.data);

                if (
                    response.data.avaliacao_normal_concluida &&
                    !response.data.avaliacao_reacao_concluida &&
                    statusAvaliacao === 'Avaliação concluída' &&
                    response.data.precisa_avaliacao_reacao
                ) {
                    setTimeout(() => {
                        setModalTemAvaliacaoReacao(true);
                    }, 3000);
                }
            } catch (error) {
                console.error("Erro ao verificar status da avaliação de reação:", error);
            }
        }

        if (dataInfoModulo[0]) {
            verificarStatusAvaliacaoReacao();
        }
    }, [dataInfoModulo, token, nivel, id, statusAvaliacao]);

    // Adicionar useEffect para verificar status da avaliação de reação híbrida
    useEffect(() => {
        async function verificarStatusAvaliacaoReacaoHibrido() {
            if (!dataInfoModulo[0] || nivel === 'Administrador' || nivel === 'Moderador') {
                return;
            }

            try {
                const response = await Api.get(`api/verificar-status-avaliacao-reacao-hibrido/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAvaliacaoReacaoHibridoStatus(response.data);

                if (
                    response.data.tipo_curso === 'misto' &&
                    response.data.avaliacao_normal_concluida &&
                    response.data.pratica_concluida &&
                    !response.data.avaliacao_reacao_hibrido_concluida &&
                    response.data.pode_responder_avaliacao_reacao_hibrido &&
                    statusAvaliacao === 'Avaliação concluída'
                ) {
                    setTimeout(() => {
                        setModalTemAvaliacaoReacaoHibrido(true);
                    }, 3000);
                }
            } catch (error) {
                console.error("Erro ao verificar status da avaliação de reação híbrida:", error);
            }
        }

        if (dataInfoModulo[0]) {
            verificarStatusAvaliacaoReacaoHibrido();
        }
    }, [dataInfoModulo, token, nivel, id, statusAvaliacao]);

    // Verificar status do certificado para este curso/módulo
    useEffect(() => {
        async function verificarStatusCertificado() {
            if (!dataInfoModulo[0] || nivel === 'Administrador' || nivel === 'Moderador') {
                setCertificadoChecked(true);
                return;
            }

            try {
                const idCurso = dataInfoModulo[0].idCurso;
                const response = await Api.get(`api/verificar-status-certificado-curso/${idCurso}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setCertificadoStatus(response.data);
                setCertificadoChecked(true);
            } catch (error) {
                console.error("Erro ao verificar status do certificado:", error);
                setCertificadoChecked(true);
            }
        }

        if (dataInfoModulo[0]) {
            verificarStatusCertificado();
        }
    }, [dataInfoModulo, token, nivel]);

    // Verificar se o usuário pode ver o PDF da prova
    const podeVerPdfProva = useCallback(() => {
        // Admins, Moderador sempre podem ver
        if (nivel === 'Administrador' || nivel === 'Moderador') {
            return true;
        }

        // Se não verificamos o certificado ainda, não permitir
        if (!certificadoChecked) {
            return false;
        }

        // Se não temos dados do certificado, não permitir
        if (!certificadoStatus) {
            return false;
        }

        // Se o certificado estiver arquivado, não permitir
        if (certificadoStatus.arquivado) {
            return false;
        }

        // Se o certificado estiver expirado, não permitir
        if (certificadoStatus.certificado_expirado) {
            return false;
        }

        // Verificar se está próximo de expirar (60 dias ou menos)
        if (certificadoStatus.pode_reiniciar) {
            return false;
        }

        // Se chegou até aqui, o certificado está válido e não está próximo de expirar
        return true;
    }, [nivel, certificadoChecked, certificadoStatus]);

    ////// Inicio Avaliação P1

    const [showModalAvaliacao, setShowModalAvaliacao] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [cursoEditarFile, setCursoEditarFile] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [progressoAvaliacao, setProgressoAvaliacao] = useState('');
    const [dataQuestoes, setDataQuestoes] = useState([]);
    const [isCreating, setIsCreating] = useState(false);

    const handleCreateNewQuestion = () => {
        setSelectedQuestao(null);
        setIsCreating(true); // Entre no modo de criação
        setAlternatives([]); // Limpa a lista de alternativas
        setValue("questao", ''); // Limpe o campo de questão
        setValue("resposta", ''); // Limpe a resposta correta
        setValue("imagem", '');
        setCursoEditarFile(false);
        setPreviewUrl(null);
        setCorrectAnswer('');
        setSelectedValue(null);
        for (let index = 0; index < 10; index++) {
            setValue(`alternativa_${index}`, '');
        }
        async function fetchData() {
            try {
                const response = await Api.get(`api/configuracao-avaliacao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setValue("data_disponibilidade", response.data[0].data_disponibilidade);
                setValue("data_disponibilidade_fim", response.data[0].data_disponibilidade_fim);
                setValue("tempo", response.data[0].tempo);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    };

    function checkStatusAvaliacao(dataInfoModulo) {
        if (!dataInfoModulo || dataInfoModulo.length === 0) {
            return "Avaliação indisponível";
        }

        const { porcentagem, disponivel, avaliacao_status } = dataInfoModulo[0].avaliacao_p1;

        // Se o modulo foi completado (porcentagem === 100)
        if (porcentagem === 100 && nivel !== 'Administrador') {
            // Se a avaliação está disponível para ser feita
            if (disponivel === 1 && avaliacao_status === 0) {
                return "Fazer avaliação";
            }
            // Se a avaliação já foi feita e concluída com sucesso
            if (avaliacao_status === 1) {
                return "Avaliação concluída";
            }
        }

        // Caso a avaliação não esteja disponível ou completa
        return "Avaliação indisponível";
    }

    // Buscar questoes
    useEffect(() => {
        setDataQuestoes([]); // Limpa a questão antes de ler a api
        async function fetchData() {
            try {
                const response = await Api.get(`api/questoes/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setDataQuestoes(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        nivel === 'Administrador' && fetchData();
    }, [token, id, reloadQuestoes, nivel]);

    // O que faz quando uma questão é selecionada
    useEffect(() => {
        if (selectedQuestao) {
            setAlternatives(JSON.parse(selectedQuestao.alternativas));
            // Use setValue para definir a alternativa correta
            setValue("resposta", selectedQuestao.resposta ? parseInt(selectedQuestao.resposta) : '');
        }
    }, [selectedQuestao, setValue, dataQuestoes]);

    const addAlternative = () => {
        setAlternatives([...alternatives, '']);
    };

    // Atualize a função removeAlternative para manter a resposta correta atualizada
    const removeAlternative = (index) => {
        const updatedAlternatives = [...alternatives];
        updatedAlternatives.splice(index, 1);
        setAlternatives(updatedAlternatives);
        setValue(`alternativa_${index}`, '');

        // Atualize a resposta correta se a alternativa removida for a correta
        if (index + 1 === correctAnswer) {
            setCorrectAnswer('');
        }
    };

    // Atualize setSelectedValues para definir o valor correto para correctAnswer
    const setSelectedValues = useCallback((selected) => {
        setValue("questao", selected.questao);
        setAlternatives(JSON.parse(selected.alternativas));
        setCorrectAnswer(selected.resposta ? parseInt(selected.resposta) : '');
    }, [setValue]);

    useEffect(() => {
        if (selectedQuestao) {
            setSelectedValues(selectedQuestao);
            setAlternatives(JSON.parse(selectedQuestao.alternativas));
            JSON.parse(selectedQuestao.alternativas).forEach((alt, index) => {
                setValue(`alternativa_${index}`, alt);
            });
        }
    }, [selectedQuestao, setSelectedValues, setValue]);

    const onSubmit = async (data) => {

        const alternativas = alternatives.map((_, index) => data[`alternativa_${index}`]);
        const resultJson = {
            questao: data.questao,
            alternativas: JSON.stringify(alternativas),
            resposta: data.resposta.toString(),
            tempo: data.tempo,
            data_disponibilidade: data.data_disponibilidade,
            data_disponibilidade_fim: data.data_disponibilidade_fim,
            imagem: data.imagem,
            idModulo: id
        };

        const formData = new FormData();

        Object.keys(resultJson).forEach(key => {
            const value = resultJson[key];  // Use resultJson aqui
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        if (isCreating) {
            // Lógica para criar uma nova questão
            try {
                const response = await Api.post(`api/criar-questao/${id}`, formData, { headers: { Authorization: `Bearer ${token}` } });
                setToast({ header: 'Sucesso!', body: response.data.message });
                setReloadAvaliacao(prev => !prev); // Atualiza o estado para recarregar
            } catch (error) {
                setToast({ header: 'Erro!', body: error.response.data.message });
                console.log(error);
            }

        } else {
            // Lógica para editar uma questão existente
            try {
                const response = await Api.post(`api/editar-questao/${selectedQuestao.id}`, formData, { headers: { Authorization: `Bearer ${token}` } });
                setToast({ header: 'Sucesso!', body: response.data.message });
                setReloadAvaliacao(prev => !prev); // Atualiza o estado para recarregar
            } catch (error) {
                setToast({ header: 'Erro!', body: error.response.data.message });
                console.log(error);
            }
        }

        setShowToast(true);
        setPreviewUrl(null);
        setReloadQuestoes(prevState => !prevState)
        setSelectedQuestao(null);
        setIsCreating(false);
        setAlternatives([]); // Limpa a lista de alternativas
        setValue("imagem", '');
        setValue("questao", ''); // Limpe o campo de questão
        setValue("resposta", ''); // Limpe a resposta correta
        setCorrectAnswer(''); // Limpa questao correta
        setSelectedValue(null); // Limpe o valor selecionado
        for (let index = 0; index < 20; index++) {
            setValue(`alternativa_${index}`, '');
        }
    };

    const {
        register: register_A,
        handleSubmit: handleSubmit_A,
        control: control_A,
        setValue: setValue_A,
        formState: { errors: errors_A },
    } = useForm();

    const handleDeleteQuestion = (id) => {

        setSelectedQuestao(null);
        setIsCreating(false);
        setAlternatives([]); // Limpa a lista de alternativas
        setValue("questao", ''); // Limpe o campo de questão
        setValue("resposta", ''); // Limpe a resposta correta
        setCorrectAnswer(''); // Limpa questao correta
        setSelectedValue(null); // Limpe o valor selecionado
        for (let index = 0; index < 20; index++) {
            setValue(`alternativa_${index}`, '');
        }

        async function fetchData() {
            try {
                const response = await Api.delete(`api/deletar-questao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setSelectedValue(null)
                setReloadQuestoes(prevState => !prevState)
                setReloadAvaliacao(prev => !prev)
                setToast({ header: 'Sucesso!', body: response.data.message })
                setShowToast(true)
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }

    //Listar avaliacao e respostas
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/info-progresso-avaliacao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setProgressoAvaliacao(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }

        nivel !== 'Administrador' && fetchData();
    }, [token, id, nivel]);

    const handleThumbnailChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setPreviewUrl(e.target.result);
            }
            reader.readAsDataURL(file);
        }
    }

    /////// Fim Avaliação P1


    // Buscar info do modulo
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/info-modulo/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setDataInfoModulo(response.data);
            } catch (error) {
                console.error(error.response.data.message)
                navigate("/");
            }
        }
        fetchData();
    }, [token, id, navigate, reloadAvaliacao]); // Adicionado reloadAvaliacao como dependência

    // Listar aulas
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-aulas/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setDataAulas(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, id, reloadAulas]);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#233734",
            "&:hover": {
                borderColor: "#3a6883"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "52px",
            margin: '0px',
            padding: '0px !important',

        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    // Buscar provas e atividades extras
    const [dataProvasExtras, setDataProvasExtras] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`/api/provas-extras-aluno/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataProvasExtras(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, id])

    const columns = useMemo(
        () => [
            {
                Header: () => null, // Sem título para esta coluna
                id: 'nome_avaliacao',
                accessor: row => row.nomeAvaliacao,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex flex-column">
                        <span className="text-bold text-wrap">{value}</span>
                        <span className="text-muted fs-7">por {original.nomeGestor ? original.nomeGestor : "Automático"}</span>
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'status',
                accessor: row => row.status,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <>
                        {value === 1 ?
                            <div className="badge bg-success text-white">Concluido</div>
                            :
                            <div className="badge bg-dark text-white">Pendente</div>
                        }
                    </>
                )
            },
            {
                Header: () => null, // Sem título para esta coluna
                id: 'id',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex justify-content-end align-items-end">
                        {original.status === 0 ? (
                            <button onClick={() => { navigate(`/questionario/extra/${original.idAvaliacao}`) }} className="btn link text-primary rounded px-2">
                                Fazer avaliação
                            </button>
                        ) : (
                            podeVerPdfProva() ? (
                                <PDFDownloadLink document={<GerarPDF data={original.idAvaliacao} tipo="avaliacao_extra" titulo={original.nomeAvaliacao} />} fileName={`avaliacao_${original.nomeAvaliacao}.pdf`}>
                                    <div className="btn link text-primary rounded px-2">
                                        Consultar
                                    </div>
                                </PDFDownloadLink>
                            ) : (
                                <Tippy content="Acesso restrito: Seu certificado está próximo de expirar. É necessário refazer o curso para ter acesso novamente.">
                                    <button className="btn btn-sm btn-outline-secondary" disabled>
                                        <i className="bi bi-lock-fill me-1"></i>Restrito
                                    </button>
                                </Tippy>
                            )
                        )}
                    </div>
                )
            }
        ], [navigate, podeVerPdfProva]
    )

    const handleDeletarAula = async (id) => {
        try {
            const response = await Api.delete(`api/deletar-aula/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setToast({ header: 'Sucesso!', body: response.data.message })

            // Remove a aula localmente primeiro
            setDataAulas(prevAulas => prevAulas.filter(aula => aula.id !== id));

            // Pequeno delay para garantir renderização
            setTimeout(async () => {
                try {
                    // Depois busca a lista atualizada do servidor
                    const aulasResponse = await Api.get(`api/listar-aulas/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                    setDataAulas(aulasResponse.data);
                } catch (error) {
                    console.error("Erro ao recarregar aulas:", error);
                }
            }, 100);

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message })
            console.error(error.response.data.message)
        }
        setShowModalDeletar(false)
        setShowToast(true)
    }

    const onSubmitEditarAula = async (data) => {

        const formData = new FormData();
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file)
                });
            } else {
                formData.append(key, value)
            }
        });

        try {
            const response = await Api.post("/api/editar-aula", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setUploadAulaProgress(percentCompleted + "%")
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadAulaProgress('Aguarde... finalizando...')
                        }, 1000)
                    }
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message })
            setFile0Selected(false)
            setFile1Selected(false)
            setFile2Selected(false)
            setUploadAulaProgress(0)
            setReloadAulas(prev => !prev); // Força o reload das aulas

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message })
            console.error("Erro ao criar nova aula:", error.response.data.message)
        }
        setShowToast(true)
    };

    const handleAtribuirNotas = async () => {
        try {
            const response = await Api.get(`/api/listar-usuarios-curso-por-modulo/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setDataUsuarios(response.data);
            setFilteredUsuarios(response.data);
            setShowModalAtribuirNotas(true);
            setSearchTerm('');
        } catch (error) {
            console.error(error.response.data.message)
        }
    };

    const handleNotaChange = (id, value) => {
        setNotas(prevNotas => ({
            ...prevNotas,
            [id]: value
        }));
    };

    const handleSearch = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);
        if (term) {
            setFilteredUsuarios(dataUsuarios.filter(usuario =>
                usuario.nome_completo.toLowerCase().includes(term)
            ));
        } else {
            setFilteredUsuarios(dataUsuarios);
        }
    };

    const handleSubmitNotas = () => {
        // console.log('Notas atribuídas:', notas);
        setShowModalAtribuirNotas(false);
        setShowModalAlunosComNotas(true);
    };

    const alunosComNotas = dataUsuarios.filter(usuario => notas[usuario.id]);

    const handleUpload = (idAluno) => {
        document.getElementById(`file-input-${idAluno}`).click();
    };

    const handleFileChange = (event, idAluno) => {
        const file = event.target.files[0];
        if (file) {
            setArquivos(prevArquivos => ({
                ...prevArquivos,
                [idAluno]: file
            }));
        }
    };

    useEffect(() => {
        const todosArquivosEnviados = alunosComNotas.every(usuario => arquivos[usuario.id]);
        setTodosArquivosEnviados(todosArquivosEnviados);
    }, [arquivos, alunosComNotas]);


    const handleGenerateQrCode = (idAluno) => {
        const url = `https://api.com/${id}/${idAluno}`;
        setQrCodeData(url);
        setShowModalQrCode(true);
        setShowModalAlunosComNotas(false);
    };

    // Função para extrair ID do YouTube
    const extractYouTubeId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    };

    // Função para validar URL do YouTube
    const validateYouTubeUrl = (url) => {
        const youtubeId = extractYouTubeId(url);
        return youtubeId ? `https://www.youtube.com/embed/${youtubeId}` : url;
    };

    const handleConcluir = async () => {
        setLoading(true)
        const dadosParaEnvio = alunosComNotas.map(usuario => ({
            idUsuario: usuario.id,
            acerto: notas[usuario.id],
            nota: notas[usuario.id]
        }));

        const formData = new FormData();
        formData.append('idModulo', id);
        formData.append('avaliacoes', JSON.stringify(dadosParaEnvio));

        alunosComNotas.forEach(usuario => {
            if (arquivos[usuario.id]) {
                formData.append(`file_${usuario.id}`, arquivos[usuario.id]);
            }
        });

        try {
            await Api.post('/api/salvar-avaliacoes', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            setShowModalFinalGrupo(true);
            setShowModalAlunosComNotas(false);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao enviar dados:', error.response.data);
        }

        // function logFormData(fd) {
        //     for (let pair of fd.entries()) {
        //         console.log(pair[0] + ': ' + pair[1]);
        //     }
        // }
        // logFormData(formData);

    };

    useEffect(() => {
        if (statusAvaliacao === 'Fazer avaliação') {
            setTimeout(() => {
                setModalTemAvaliacao(true);
            }, 2000);
        }
    }, [statusAvaliacao]);

    const handleDeleteAvaliacao = async () => {
        try {
            const response = await Api.delete(`api/deletar-avaliacao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setToast({ header: 'Sucesso!', body: response.data.message });
            setShowToast(true);
            setShowModalDeletarAvaliacao(false);
            setShowModalAvaliacao(true); // Reabre o modal anterior
            setReloadAvaliacao(prev => !prev);
            setReloadQuestoes(prev => !prev); // Força atualização das questões

            // Recarrega as questões
            const questoesResponse = await Api.get(`api/questoes/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setDataQuestoes(questoesResponse.data);
        } catch (error) {
            setToast({ header: 'Erro!', body: error.response.data.message });
            setShowToast(true);
        }
    };

    const onSubmitNovaAula = async (data) => {
        // Verificar se temos os dados necessários
        if (!dataInfoModulo[0] || !dataInfoModulo[0].idCurso) {
            setToast({ header: 'Erro!', body: 'Dados do módulo não encontrados. Tente recarregar a página.' });
            setShowToast(true);
            return;
        }

        const formData = new FormData();
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file)
                });
            } else {
                formData.append(key, value)
            }
        });

        formData.append('idModulo', id);
        formData.append('idCurso', dataInfoModulo[0].idCurso);
        formData.append('curso', JSON.stringify({
            value: dataInfoModulo[0].idCurso,
            label: dataInfoModulo[0].nomeCurso || 'Curso'
        }));
        formData.append('modulo', JSON.stringify({
            value: id,
            label: dataInfoModulo[0].nome || 'Módulo'
        }));

        try {
            const response = await Api.post("/api/novo-aula", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setUploadAulaProgressNova(percentCompleted + "%")
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadAulaProgressNova('Aguarde... finalizando...')
                        }, 1000)
                    }
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message })
            setFile0SelectedNova(false)
            setFile1SelectedNova(false)
            setFile2SelectedNova(false)
            setUploadAulaProgressNova(0)
            setReloadAulas(prev => !prev); // Força o reload das aulas
            setShowModalNovaAula(false);
            reset_Nova();

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message })
            console.error("Erro ao criar nova aula:", error.response.data.message)
        }
        setShowToast(true)
    };

    return (
        <>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            {dataInfoModulo[0] &&

                <div className="fade-in w-100 mb-5">
                    <Link to={`/modulos/${dataInfoModulo[0].idCurso}`} className="btn text-primary link border-0 fs-6"><i className="bi bi-chevron-left"></i>Voltar</Link>

                    {/* Banner responsivo com versões para desktop e mobile */}
                    <div className="card card-flag rounded-5 w-100 overflow-hidden mb-3 border-none position-relative" style={{ minHeight: '80px', maxHeight: '100px' }}>
                        {/* Imagem e overlay do banner */}
                        <img src={`${process.env.REACT_APP_IMG_URL}/${dataInfoModulo[0].thumbnail}`} className="card-img w-100" style={{ height: '100px', objectFit: 'cover' }} alt={dataInfoModulo[0].nome} />
                        <div className="position-absolute w-100 h-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}></div>

                        {/* Conteúdo adaptativo do banner */}
                        <div className="card-img-overlay d-flex flex-column justify-content-center align-items-center p-2">
                            {/* Cabeçalho com título */}
                            <div className="text-white text-center">
                                <h6 className="mb-0 fs-5">{dataInfoModulo[0].nome}</h6>
                            </div>
                        </div>
                    </div>

                    <div className="body p-1 p-md-3">
                        <section className="w-100">

                            {dataInfoModulo[0].descricao &&
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-primary fw-bold mb-0">Descrição do Módulo</h5>
                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => setDescricaoExpandida(!descricaoExpandida)}
                                                >
                                                    <i className={`bi bi-chevron-${descricaoExpandida ? 'up' : 'down'}`}></i>
                                                </button>
                                                
                                                {/* Botão Nova Aula - Visível apenas no desktop */}
                                                {nivel === 'Administrador' && (
                                                    <button
                                                        onClick={() => setShowModalNovaAula(true)}
                                                        className="btn btn-primary btn-sm d-none d-lg-block"
                                                    >
                                                        <i className="bi bi-plus-circle me-1"></i>
                                                        Nova Aula
                                                    </button>
                                                )}

                                                {/* Dropdown Menu */}
                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm dropdown-toggle"
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <i className="bi bi-three-dots-vertical me-1"></i>
                                                        Menu
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {/* Nova Aula - Visível apenas no mobile */}
                                                        {nivel === 'Administrador' && (
                                                            <li className="d-lg-none">
                                                                <span className="dropdown-item" onClick={() => setShowModalNovaAula(true)} style={{ cursor: 'pointer' }}>
                                                                    <i className="bi bi-plus-circle me-2"></i>
                                                                    Nova Aula
                                                                </span>
                                                            </li>
                                                        )}

                                                        {nivel !== 'Administrador' && (
                                                            (() => {
                                                                if (statusAvaliacao === "Fazer avaliação") {
                                                                    return (
                                                                        <li>
                                                                            <Link to={`/questionario/${id}`} className="dropdown-item text-warning">
                                                                                <i className="bi bi-clipboard-check me-2"></i>
                                                                                Fazer avaliação
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                } else if (statusAvaliacao === "Avaliação concluída" && avaliacaoReacaoStatus && !avaliacaoReacaoStatus.avaliacao_reacao_concluida && avaliacaoReacaoStatus.precisa_avaliacao_reacao) {
                                                                    return (
                                                                        <li>
                                                                            <Link to={`/questionario/reacao/${id}`} className="dropdown-item text-success">
                                                                                <i className="bi bi-clipboard-check me-2"></i>
                                                                                Avaliação de Reação
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                } else if (statusAvaliacao === "Avaliação concluída" && avaliacaoReacaoHibridoStatus && avaliacaoReacaoHibridoStatus.pode_responder_avaliacao_reacao_hibrido && !avaliacaoReacaoHibridoStatus.avaliacao_reacao_hibrido_concluida) {
                                                                    return (
                                                                        <li>
                                                                            <Link to={`/questionario/reacao-hibrido/${id}`} className="dropdown-item text-success">
                                                                                <i className="bi bi-clipboard-check me-2"></i>
                                                                                Avaliação de Reação
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                } else if (statusAvaliacao === "Avaliação concluída") {
                                                                    return null;
                                                                } else {
                                                                    return (
                                                                        <li>
                                                                            <span className="dropdown-item text-muted">
                                                                                <i className="bi bi-clipboard-x me-2"></i>
                                                                                Avaliação indisponível
                                                                            </span>
                                                                        </li>
                                                                    );
                                                                }
                                                            })()
                                                        )}

                                                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                                            <li>
                                                                <Link to="#" onClick={handleAtribuirNotas} className="dropdown-item">
                                                                    <i className="bi bi-people me-2"></i>
                                                                    Atribuir notas em grupo
                                                                </Link>
                                                            </li>
                                                        )}

                                                        {nivel === 'Administrador' && (
                                                            <li>
                                                                <Link onClick={() => setShowModalAvaliacao(true)} className="dropdown-item">
                                                                    <i className="bi bi-gear me-2"></i>
                                                                    Configurar Avaliação
                                                                </Link>
                                                            </li>
                                                        )}

                                                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                                            <li>
                                                                <PDFDownloadLink
                                                                    document={<GerarPDF data={dataInfoModulo && dataInfoModulo[0].id} tipo="avaliacao_normal_visualizacao" titulo={dataInfoModulo && dataInfoModulo[0].nome} reloadAvaliacao={reloadAvaliacao} />}
                                                                    fileName={`avaliacao_${dataInfoModulo && dataInfoModulo[0].nome}.pdf`}
                                                                    className="dropdown-item"
                                                                >
                                                                    <i className="bi bi-printer me-2"></i>
                                                                    Imprimir Avaliação
                                                                </PDFDownloadLink>
                                                            </li>
                                                        )}

                                                        {nivel !== 'Administrador' && (
                                                            <>
                                                                <li>
                                                                    <Link onClick={() => setShowModalAtividadeExtra(true)} className="dropdown-item">
                                                                        <i className="bi bi-file-earmark-text me-2"></i>
                                                                        Atividades / Provas extras
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <span className="dropdown-item" onClick={() => setShowModalMinhasNotas(true)} style={{ cursor: 'pointer' }}>
                                                                        <i className="bi bi-journal-text me-2"></i>
                                                                        Minhas notas
                                                                    </span>
                                                                </li>
                                                            </>
                                                        )}
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                        {descricaoExpandida && (
                                            <p className="text-muted">{dataInfoModulo[0].descricao}</p>
                                        )}
                                    </div>
                                </div>
                            }

                            {!dataInfoModulo[0].descricao && (
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="text-primary fw-bold mb-0">Aulas do Módulo</h5>
                                            <div className="d-flex gap-2">
                                                {/* Botão Nova Aula - Visível apenas no desktop */}
                                                {nivel === 'Administrador' && (
                                                    <button
                                                        onClick={() => setShowModalNovaAula(true)}
                                                        className="btn btn-primary btn-sm d-none d-lg-block"
                                                    >
                                                        <i className="bi bi-plus-circle me-1"></i>
                                                        Nova Aula
                                                    </button>
                                                )}

                                                {/* Dropdown Menu para módulos sem descrição */}
                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm dropdown-toggle"
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <i className="bi bi-three-dots-vertical me-1"></i>
                                                        Menu
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {/* Nova Aula - Visível apenas no mobile */}
                                                        {nivel === 'Administrador' && (
                                                            <li className="d-lg-none">
                                                                <span className="dropdown-item" onClick={() => setShowModalNovaAula(true)} style={{ cursor: 'pointer' }}>
                                                                    <i className="bi bi-plus-circle me-2"></i>
                                                                    Nova Aula
                                                                </span>
                                                            </li>
                                                        )}

                                                        {nivel !== 'Administrador' && (
                                                            (() => {
                                                                if (statusAvaliacao === "Fazer avaliação") {
                                                                    return (
                                                                        <li>
                                                                            <Link to={`/questionario/${id}`} className="dropdown-item text-warning">
                                                                                <i className="bi bi-clipboard-check me-2"></i>
                                                                                Fazer avaliação
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                } else if (statusAvaliacao === "Avaliação concluída" && avaliacaoReacaoStatus && !avaliacaoReacaoStatus.avaliacao_reacao_concluida && avaliacaoReacaoStatus.precisa_avaliacao_reacao) {
                                                                    return (
                                                                        <li>
                                                                            <Link to={`/questionario/reacao/${id}`} className="dropdown-item text-success">
                                                                                <i className="bi bi-clipboard-check me-2"></i>
                                                                                Avaliação de Reação
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                } else if (statusAvaliacao === "Avaliação concluída" && avaliacaoReacaoHibridoStatus && avaliacaoReacaoHibridoStatus.pode_responder_avaliacao_reacao_hibrido && !avaliacaoReacaoHibridoStatus.avaliacao_reacao_hibrido_concluida) {
                                                                    return (
                                                                        <li>
                                                                            <Link to={`/questionario/reacao-hibrido/${id}`} className="dropdown-item text-success">
                                                                                <i className="bi bi-clipboard-check me-2"></i>
                                                                                Avaliação de Reação
                                                                            </Link>
                                                                        </li>
                                                                    );
                                                                } else if (statusAvaliacao === "Avaliação concluída") {
                                                                    return null;
                                                                } else {
                                                                    return (
                                                                        <li>
                                                                            <span className="dropdown-item text-muted">
                                                                                <i className="bi bi-clipboard-x me-2"></i>
                                                                                Avaliação indisponível
                                                                            </span>
                                                                        </li>
                                                                    );
                                                                }
                                                            })()
                                                        )}

                                                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                                            <li>
                                                                <Link to="#" onClick={handleAtribuirNotas} className="dropdown-item">
                                                                    <i className="bi bi-people me-2"></i>
                                                                    Atribuir notas em grupo
                                                                </Link>
                                                            </li>
                                                        )}

                                                        {nivel === 'Administrador' && (
                                                            <li>
                                                                <Link onClick={() => setShowModalAvaliacao(true)} className="dropdown-item">
                                                                    <i className="bi bi-gear me-2"></i>
                                                                    Configurar Avaliação
                                                                </Link>
                                                            </li>
                                                        )}

                                                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                                            <li>
                                                                <PDFDownloadLink
                                                                    document={<GerarPDF data={dataInfoModulo && dataInfoModulo[0].id} tipo="avaliacao_normal_visualizacao" titulo={dataInfoModulo && dataInfoModulo[0].nome} reloadAvaliacao={reloadAvaliacao} />}
                                                                    fileName={`avaliacao_${dataInfoModulo && dataInfoModulo[0].nome}.pdf`}
                                                                    className="dropdown-item"
                                                                >
                                                                    <i className="bi bi-printer me-2"></i>
                                                                    Imprimir Avaliação
                                                                </PDFDownloadLink>
                                                            </li>
                                                        )}

                                                        {nivel !== 'Administrador' && (
                                                            <>
                                                                <li>
                                                                    <Link onClick={() => setShowModalAtividadeExtra(true)} className="dropdown-item">
                                                                        <i className="bi bi-file-earmark-text me-2"></i>
                                                                        Atividades / Provas extras
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <span className="dropdown-item" onClick={() => setShowModalMinhasNotas(true)} style={{ cursor: 'pointer' }}>
                                                                        <i className="bi bi-journal-text me-2"></i>
                                                                        Minhas notas
                                                                    </span>
                                                                </li>
                                                            </>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="row mb-3 pb-5 pb-md-0">
                                {dataAulas.map((value, index) => {
                                    return (
                                        <div key={`aula-${value.id}-${reloadAulas}`} className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mt-2">
                                            <div className={`card-body mt-3 shadow-sm rounded-4 p-3 ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador')
                                                ? 'bg-success'
                                                : 'bg-white'
                                                }`}>
                                                {/* Cabeçalho do Card */}
                                                <div className="d-flex flex-column mb-2">
                                                    <div className={`card-title ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador')
                                                        ? 'text-white'
                                                        : 'text-primary'
                                                        }`}>
                                                        <div className="d-flex align-items-center mb-1">
                                                            <span className={`small border border-2 rounded-3 px-2 fw-bold fs-6 ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador')
                                                                ? 'text-white border-white'
                                                                : 'text-primary border-primary'
                                                                }`}>
                                                                Aula {index + 1}
                                                            </span>
                                                        </div>
                                                        <h6 className={`mb-0 ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador')
                                                            ? 'text-white'
                                                            : 'text-dark'
                                                            }`} style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>
                                                            {value.titulo}
                                                        </h6>
                                                    </div>
                                                </div>

                                                {/* Área de Ações */}
                                                <div className="d-flex flex-wrap align-items-center gap-1">
                                                    {/* Badge Assistida */}
                                                    {value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador') && (
                                                        <span className="bg-white text-success rounded-3 p-1 fs-8">
                                                            <i className="bi bi-check-circle-fill"></i> Assistida
                                                        </span>
                                                    )}

                                                    {/* Botões de Acesso */}
                                                    <div className="d-flex flex-wrap gap-1 ms-auto">
                                                        {/* Botão Acessar - não exibir para cursos presenciais */}
                                                        {dataInfoModulo[0]?.tipo_curso !== 'presencial' && (
                                                            <Link
                                                                to={`/aula/${value.id}`}
                                                                className={`btn btn-sm ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador')
                                                                    ? 'text-white'
                                                                    : 'text-dark link'
                                                                    }`}
                                                                style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                                                            >
                                                                Acessar
                                                            </Link>
                                                        )}

                                                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                                            <Link
                                                                to={`/aula-grupo/${value.id}`}
                                                                className={`btn btn-sm ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'Moderador')
                                                                    ? 'text-white'
                                                                    : 'text-dark link'
                                                                    }`}
                                                                style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                                                            >
                                                                Grupo
                                                            </Link>
                                                        )}
                                                    </div>

                                                    {/* Ações do Administrador */}
                                                    {nivel === 'Administrador' && (
                                                        <div className="d-flex gap-1">
                                                            <Tippy content="Editar Aula">
                                                                <button
                                                                    onClick={() => {
                                                                        setShowModalEditarAula(true)
                                                                        setValue_A('id', value.id)
                                                                        setValue_A('titulo', value.titulo)
                                                                        setValue_A('descricao', value.descricao)
                                                                        setValue_A('resumo', value.resumo)
                                                                        setUploadAulaProgress(0)

                                                                        // Detectar tipo de conteúdo baseado nos dados existentes
                                                                        if (value.html_externo) {
                                                                            setTipoConteudoEditar('url_externa')
                                                                            setValue_A('html_externo', value.html_externo)
                                                                        } else {
                                                                            setTipoConteudoEditar('arquivo')
                                                                        }
                                                                    }}
                                                                    className="btn btn-sm btn-primary"
                                                                    style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                                                                >
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                            </Tippy>

                                                            <Tippy content="Excluir Aula">
                                                                <button
                                                                    onClick={() => { setShowModalDeletar(true); setDeletarAula({ id: value.id, titulo: value.titulo }) }}
                                                                    className="btn btn-sm btn-primary"
                                                                    style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                                                                >
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                            </Tippy>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </div>

                        </section>
                    </div>

                </div>
            }

            <Modal size="lg" show={modalTemAvaliacao} onHide={() => setModalTemAvaliacao(false)} centered>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">📋 Avaliação Disponível</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column w-100 text-center">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="fs-5">🎉 A avaliação do módulo <strong>{dataInfoModulo[0] && dataInfoModulo[0].nome}</strong> está disponível!</p>
                                    <p className="fs-6">Clique no botão abaixo para iniciar sua avaliação.</p>
                                    <Link to={`/questionario/${id}`} className="btn btn-secondary text-white mt-3">Iniciar Avaliação</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={modalTemAvaliacaoReacao} onHide={() => setModalTemAvaliacaoReacao(false)} centered>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">🌟 Avaliação de Reação</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column w-100 text-center">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="fs-5">✅ Parabéns por concluir a avaliação do módulo <strong>{dataInfoModulo[0] && dataInfoModulo[0].nome}</strong>!</p>
                                    <p className="fs-6">Agora, precisamos que você responda à <strong>Avaliação de Reação</strong> para liberar seu certificado.</p>
                                    <p className="fs-7 text-muted">Esta avaliação é sobre sua experiência com o treinamento.</p>
                                    <Link to={`/questionario/reacao/${id}`} className="btn btn-primary text-white mt-3">Responder Avaliação de Reação</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={modalTemAvaliacaoReacaoHibrido} onHide={() => setModalTemAvaliacaoReacaoHibrido(false)} centered>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">🌟 Avaliação de Reação - Curso Misto</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column w-100 text-center">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="fs-5">✅ Você já completou as aulas, a avaliação e a prática do curso <strong>{dataInfoModulo[0] && dataInfoModulo[0].nome}</strong>!</p>
                                    <p className="fs-6">Agora, para finalizar e receber seu certificado, precisamos que você responda à <strong>Avaliação de Reação para Cursos Mistos</strong>.</p>
                                    <p className="fs-7 text-muted">Esta avaliação é sobre sua experiência com o treinamento teórico e prático.</p>
                                    <Link to={`/questionario/reacao-hibrido/${id}`} className="btn btn-primary text-white mt-3">Responder Avaliação de Reação</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={showModalAvaliacao} onHide={() => {
                setShowModalAvaliacao(false);
                setSelectedQuestao(null);
                setIsCreating(false);
                setSelectedValue(null);
                reset();
                for (let index = 0; index < 10; index++) {
                    setValue(`alternativa_${index}`, '');
                }
            }}>
                <Modal.Header closeButton>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <span className="fw-semibold fs-4 text-primary">Avaliação <span className="text-dark fs-5">({dataInfoModulo[0] && dataInfoModulo[0].nome})</span></span>
                        <i
                            className="bi bi-trash cursor-pointer me-2 text-danger fs-5"
                            onClick={() => {
                                setShowModalAvaliacao(false);
                                setShowModalDeletarAvaliacao(true);
                            }}
                        ></i>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex mb-1">
                                        <div className="d-flex flex-column w-100">

                                            <div className="row mb-3">

                                                <div className="col-12">
                                                    {!isCreating && (
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Selecione a questão</label>

                                                            <Controller
                                                                name="questaoSelecionada"
                                                                control={control}
                                                                defaultValue={[]}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        {...field}
                                                                        options={dataQuestoes.map((value, index) => {
                                                                            setValue("tempo", dataQuestoes[0].tempo);
                                                                            return {
                                                                                value: value.id,
                                                                                label: `${index + 1} - ${truncateString(value.questao)}`,
                                                                            };
                                                                        })}
                                                                        value={selectedValue} // Use o estado aqui
                                                                        styles={customStyles}
                                                                        onChange={(value) => {
                                                                            if (value && selectedQuestao && value.value === selectedQuestao.id) return;
                                                                            field.onChange(value);
                                                                            setSelectedValue(value); // Atualize o estado aqui
                                                                            const selected = dataQuestoes.find((q) => q.id === value.value);
                                                                            setSelectedQuestao(selected);
                                                                            setValue("data_disponibilidade", dataQuestoes[0].data_disponibilidade);
                                                                            setValue("data_disponibilidade_fim", dataQuestoes[0].data_disponibilidade_fim);
                                                                        }}
                                                                        placeholder="Selecione uma questão"
                                                                        isSearchable
                                                                        noOptionsMessage={() => "Nenhuma questão encontrada."}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    )}

                                                    <p className="btn-link fs-7 ms-2 cursor-pointer" onClick={handleCreateNewQuestion}>Adicionar nova questão</p>
                                                    {dataInfoModulo[0] && nivel === "Administrador" &&
                                                        <PDFDownloadLink
                                                            document={<GerarPDF data={dataInfoModulo[0].id} tipo="avaliacao_completa_visualizacao" titulo={dataInfoModulo[0].nome} reloadAvaliacao={reloadAvaliacao} />}
                                                            fileName={`avaliacao_${dataInfoModulo[0].nome}.pdf`}
                                                        >
                                                            <p className="btn-link fs-7 ms-2 cursor-pointer">Visualizar avaliação</p>
                                                        </PDFDownloadLink>
                                                    }

                                                </div>

                                            </div>
                                            {(selectedQuestao || isCreating) && (
                                                <>
                                                    <div className="row mb-3">
                                                        <div className="col-12 col-md-12">
                                                            <div className="mb-3">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <label className="form-label text-primary fw-medium mb-0">Questão</label>
                                                                    {!isCreating && (
                                                                        <>
                                                                            <i className="bi bi-trash cursor-pointer tt-deletar" onClick={() => handleDeleteQuestion(selectedQuestao.id)}></i>
                                                                            <Tippy content="Deletar essa questão">
                                                                                <i className="bi bi-trash cursor-pointer tt-deletar" onClick={() => handleDeleteQuestion(selectedQuestao.id)}></i>
                                                                            </Tippy>
                                                                        </>
                                                                    )}
                                                                </div>

                                                                <TextareaAutosize
                                                                    rows={3}
                                                                    {...register("questao", { required: true, defaultValue: selectedQuestao ? selectedQuestao.questao : '' })}
                                                                    className="form-control border-primary"
                                                                />
                                                                {errors.questao && <span className='text-danger fs-7'>Questão é obrigatório.</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-12">
                                                            <div className="mb-3">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <label className="form-label text-primary fw-medium mb-0">Imagem</label>
                                                                </div>

                                                                <label htmlFor="imagem" className={`form-control label-input ${cursoEditarFile ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center`}>
                                                                    <i className="bi bi-card-image me-2"></i> Enviar Imagem
                                                                </label>

                                                                <Controller
                                                                    control={control}
                                                                    name="imagem"
                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                        <input
                                                                            id='imagem'
                                                                            type="file"
                                                                            onBlur={onBlur}
                                                                            ref={ref}
                                                                            onChange={(e) => {
                                                                                const files = e.target.files;
                                                                                handleThumbnailChange(e);
                                                                                onChange(files);
                                                                                if (files && files.length > 0) {
                                                                                    setCursoEditarFile(true);
                                                                                } else {
                                                                                    setCursoEditarFile(false);
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                                />

                                                                {previewUrl ?
                                                                    <div className="d-flex justify-content-center mt-2">
                                                                        <img src={previewUrl} className='card-img-question-edit rounded-3' alt="Thumbnail" />
                                                                    </div>
                                                                    :
                                                                    <div className="d-flex justify-content-center mt-2">
                                                                        {selectedQuestao && selectedQuestao.imagem &&
                                                                            <img src={`${process.env.REACT_APP_IMG_URL}/${selectedQuestao.imagem}`} className='card-img-question-edit rounded-3' alt="Thumbnail" />
                                                                        }
                                                                    </div>
                                                                }


                                                            </div>
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium col-12">Alternativas</label>
                                                            {alternatives.map((_, index) => (
                                                                <div className="input-group mb-3" key={index}>
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text bg-primary text-white" id="basic-addon1">{index + 1}</span>
                                                                    </div>
                                                                    <input type="text" {...register(`alternativa_${index}`, { required: true })} className="form-control border-primary" />
                                                                    <button type="button" className="btn btn-primary text-white" onClick={() => removeAlternative(index)}>-</button>
                                                                </div>
                                                            ))}
                                                            <button className="btn btn-primary text-white" type="button" onClick={addAlternative}>+</button>
                                                        </div>


                                                        <div className="col-12 col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Alternativa Correta</label>
                                                                <select
                                                                    {...register("resposta")}
                                                                    value={correctAnswer} // Use correctAnswer aqui
                                                                    onChange={(e) => setCorrectAnswer(Number(e.target.value))}
                                                                    aria-label="Default select example"
                                                                    className="form-select border-primary"
                                                                >
                                                                    <option value="">Selecione a alternativa correta</option>
                                                                    {alternatives.map((_, index) => (
                                                                        <option key={index} value={index + 1}>
                                                                            Alternativa {index + 1}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Tempo da avaliação</label>
                                                                <input
                                                                    type="number"
                                                                    {...register("tempo", { required: true })}
                                                                    className="form-control border-primary"
                                                                    placeholder="Digite o tempo da avaliação em minutos"
                                                                />
                                                                <label className="form-label text-dark fw-normal fs-7">em minutos</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Data de Disponibilidade</label>
                                                                <input
                                                                    type="date"
                                                                    {...register("data_disponibilidade", { required: true })}
                                                                    className="form-control border-primary"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Disponível até</label>
                                                                <input
                                                                    type="date"
                                                                    {...register("data_disponibilidade_fim", { required: true })}
                                                                    className="form-control border-primary"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {(selectedQuestao || isCreating) && (

                            <div className="d-flex justify-content-center mb-3">
                                <button type="submit" className="btn btn-primary text-white px-5 py-2">
                                    Salvar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary text-primary px-5 py-2 ms-4"
                                    onClick={() => {
                                        setShowModalAvaliacao(false);
                                        setSelectedQuestao(null);
                                        setIsCreating(false);
                                        reset();
                                        setSelectedValue(null);
                                        for (let index = 0; index < 10; index++) {
                                            setValue(`alternativa_${index}`, '');
                                        }
                                    }}
                                >
                                    Voltar
                                </button>
                            </div>
                        )}


                    </form>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={showModalEditarAula} onHide={() => {
                setShowModalEditarAula(false);
                setTipoConteudoEditar('arquivo');
            }}>
                <form onSubmit={handleSubmit_A(onSubmitEditarAula)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-4 text-primary">Editar Aula</span>
                    </Modal.Header>
                    <Modal.Body>
                        <input type="hidden" {...register_A('id', { required: true })} />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="body">
                                        <div className="d-flex mb-5">
                                            <div className="d-flex flex-column w-100">
                                                <div className="row">

                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className='col-12 h-100 red-bg d-flex align-items-center justify-content-center rounded-3'>
                                                                <i className="bi bi-cloud-upload icon-large text-white"></i>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8 mt-3">
                                                            <div className="row">
                                                                <div className="col-12 col-md-12">
                                                                    <div className="mb-3">
                                                                        <input type="text" {...register_A("titulo", { required: true })} placeholder="Título da aula" className="form-control border-primary" />
                                                                        {errors_A.titulo && <span className='text-danger fs-7'>Aula é obrigatório.</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="col-12 col-md-12">
                                                                    <div className="mb-3">
                                                                        <TextareaAutosize type="text" {...register_A("descricao", { required: true })} placeholder="Descrição da aula" className="form-control border-primary" />
                                                                        {errors_A.descricao && <span className='text-danger fs-7'>Aula é obrigatório.</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Seletor de Tipo de Conteúdo - Não exibir para cursos presenciais */}
                                                    {dataInfoModulo[0]?.tipo_curso !== 'presencial' && (
                                                        <>
                                                            <div className="row mt-3">
                                                                <div className="col-12">
                                                                    <div className="mb-3">
                                                                        <label className="form-label text-primary fw-medium">Tipo de Conteúdo</label>
                                                                        <div className="btn-group w-100" role="group">
                                                                            <input
                                                                                type="radio"
                                                                                className="btn-check"
                                                                                name="tipoConteudoEditar"
                                                                                id="tipoArquivoEditar"
                                                                                value="arquivo"
                                                                                checked={tipoConteudoEditar === 'arquivo'}
                                                                                onChange={(e) => setTipoConteudoEditar(e.target.value)}
                                                                            />
                                                                            <label className="btn btn-outline-primary" htmlFor="tipoArquivoEditar">
                                                                                <i className="bi bi-file-earmark-fill me-2"></i>
                                                                                Arquivo
                                                                            </label>

                                                                            <input
                                                                                type="radio"
                                                                                className="btn-check"
                                                                                name="tipoConteudoEditar"
                                                                                id="tipoUrlExternaEditar"
                                                                                value="url_externa"
                                                                                checked={tipoConteudoEditar === 'url_externa'}
                                                                                onChange={(e) => setTipoConteudoEditar(e.target.value)}
                                                                            />
                                                                            <label className="btn btn-outline-primary" htmlFor="tipoUrlExternaEditar">
                                                                                <i className="bi bi-link-45deg me-2"></i>
                                                                                URL Externa
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Campos baseados no tipo de conteúdo */}
                                                            {tipoConteudoEditar === 'arquivo' && (
                                                        <div className='row mt-3'>
                                                            <div className="col-6 col-md-4">
                                                                <div className="mb-3">
                                                                    <div className="card border-none">
                                                                        <p className='fs-7'>Arquivo da aula</p>
                                                                        <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                            <i className="bi bi-file-earmark-fill"></i>
                                                                        </h5>
                                                                        <div className="card-body d-flex justify-content-center bg-light">
                                                                            <p className="card-text fs-7">
                                                                                <label htmlFor="file_0" className={`cursor-pointer ${file0Selected ? 'text-success' : 'text-primary'}`}>Fazer Upload <i className="bi bi-cloud-upload"></i></label>
                                                                                <Controller
                                                                                    control={control_A}
                                                                                    name="file_0"
                                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                                        <input
                                                                                            id='file_0'
                                                                                            type="file"
                                                                                            onBlur={onBlur}
                                                                                            ref={ref}
                                                                                            onChange={(e) => {
                                                                                                const files = e.target.files;
                                                                                                onChange(files);
                                                                                                if (files && files.length > 0) {
                                                                                                    setFile0Selected(true);
                                                                                                } else {
                                                                                                    setFile0Selected(false);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 col-md-4 border-start border-primary">
                                                                <div className="mb-3">
                                                                    <div className="card border-none">
                                                                        <p className='fs-7'>Arquivo Auxiliar 1</p>
                                                                        <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                            <i className="bi bi-file-earmark-fill"></i>
                                                                        </h5>
                                                                        <div className="card-body d-flex justify-content-center bg-light">
                                                                            <p className="card-text fs-7">
                                                                                <label htmlFor="file_1" className={`cursor-pointer ${file1Selected ? 'text-success' : 'text-primary'}`}>Fazer Upload  <i className="bi bi-cloud-upload"></i></label>
                                                                                <Controller
                                                                                    control={control_A}
                                                                                    name="file_1"
                                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                                        <input
                                                                                            id='file_1'
                                                                                            type="file"
                                                                                            onBlur={onBlur}
                                                                                            ref={ref}
                                                                                            onChange={(e) => {
                                                                                                const files = e.target.files;
                                                                                                onChange(files);
                                                                                                if (files && files.length > 0) {
                                                                                                    setFile1Selected(true);
                                                                                                } else {
                                                                                                    setFile1Selected(false);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-4">
                                                                <div className="mb-3">
                                                                    <div className="card border-none">
                                                                        <p className='fs-7'>Arquivo Auxiliar 2</p>
                                                                        <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                            <i className="bi bi-file-earmark-fill"></i>
                                                                        </h5>
                                                                        <div className="card-body d-flex justify-content-center bg-light">
                                                                            <p className="card-text text-primary fs-7">
                                                                                <label htmlFor="file_2" className={`cursor-pointer ${file2Selected ? 'text-success' : 'text-primary'}`}>Fazer Upload  <i className="bi bi-cloud-upload"></i></label>

                                                                                <Controller
                                                                                    control={control_A}
                                                                                    name="file_2"
                                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                                        <input
                                                                                            id='file_2'
                                                                                            type="file"
                                                                                            onBlur={onBlur}
                                                                                            ref={ref}
                                                                                            onChange={(e) => {
                                                                                                const files = e.target.files;
                                                                                                onChange(files);
                                                                                                if (files && files.length > 0) {
                                                                                                    setFile2Selected(true);
                                                                                                } else {
                                                                                                    setFile2Selected(false);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                                {errors_A.file_0 && <span className='text-danger fs-7'>Arquivo da aula é obrigatório.</span>}
                                                            </div>
                                                            )}

                                                            {tipoConteudoEditar === 'url_externa' && (
                                                                <div className='row mt-3'>
                                                                    <div className="col-12">
                                                                        <div className="mb-3">
                                                                            <label className="form-label text-primary fw-medium">URL Externa</label>
                                                                            <input
                                                                                type="url"
                                                                                {...register_A("html_externo", {
                                                                                    required: tipoConteudoEditar === 'url_externa',
                                                                                    pattern: {
                                                                                        value: /^https?:\/\/.+/,
                                                                                        message: "URL deve começar com http:// ou https://"
                                                                                    }
                                                                                })}
                                                                                placeholder="https://exemplo.com/conteudo ou https://www.youtube.com/watch?v=VIDEO_ID"
                                                                                className="form-control border-primary"
                                                                                onChange={(e) => {
                                                                                    const url = e.target.value;
                                                                                    if (url) {
                                                                                        // Se for YouTube, converte para embed
                                                                                        if (url.includes('youtube.com') || url.includes('youtu.be')) {
                                                                                            const embedUrl = validateYouTubeUrl(url);
                                                                                            setValue_A("html_externo", embedUrl);
                                                                                        } else {
                                                                                            setValue_A("html_externo", url);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            />
                                                                            {errors_A.html_externo && <span className='text-danger fs-7'>{errors_A.html_externo.message || 'URL externa é obrigatória.'}</span>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* Aviso para cursos presenciais */}
                                                    {dataInfoModulo[0]?.tipo_curso === 'presencial' && (
                                                        <div className="row mt-3">
                                                            <div className="col-12">
                                                                <div className="alert alert-info">
                                                                    <i className="bi bi-info-circle me-2"></i>
                                                                    Cursos presenciais não requerem upload de arquivos. O conteúdo será ministrado presencialmente.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Campo oculto para html_externo */}
                                                    <input
                                                        type="hidden"
                                                        {...register_A("html_externo")}
                                                    />

                                                </div>
                                                <div className="progress col-12 mt-4">
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${uploadAulaProgress}` }} aria-valuenow={uploadAulaProgress} aria-valuemin="0" aria-valuemax="100">{uploadAulaProgress}</div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center bg-light">
                        <button type="submit" className="btn btn-primary text-white px-5 py-2">Salvar</button>
                        <button type="button" className="btn btn-outline-primary text-primary px-5 py-2" onClick={() => setShowModalEditarAula(false)}> Cancelar </button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size='lg' show={showModalDeletar} onHide={() => setShowModalDeletar(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Deletar aula</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Tem certeza que deseja deletar a aula <b>{deletarAula.titulo}</b>?</p>
                                                    <p>Essa ação ira deletar a aula e seu conteúdo? Não será possível recuperar.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center bg-light">
                    <button type="submit" className="btn btn-primary text-white px-5 py-2" onClick={() => handleDeletarAula(deletarAula.id)}>Confirmar</button>
                    <button type="button" className="btn btn-outline-primary text-primary px-5 py-2" onClick={() => setShowModalDeletar(false)}>Cancelar</button>
                </Modal.Footer>
            </Modal>

            <Modal size="xl" show={showModalMinhasNotas} onHide={() => setShowModalMinhasNotas(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Minhas Avaliações</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Módulo</th>
                                                                <th scope="col" className="text-center">Acertos</th>
                                                                <th scope="col" className="text-center">Nota</th>
                                                                <th scope="col" className="text-center">Data</th>
                                                                <th scope="col" className="text-center">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        {progressoAvaliacao &&
                                                            <tbody>
                                                                {progressoAvaliacao.progresso_avaliacao &&
                                                                    <tr>
                                                                        <td className="text-start fw-normal text-nowrap">
                                                                            <Tippy content={`${progressoAvaliacao.progresso_avaliacao.nomeModulo} - Avaliação`}>
                                                                                <span>{truncateString(progressoAvaliacao.progresso_avaliacao.nomeModulo, 30)} - <b>Avaliação</b></span>
                                                                            </Tippy>
                                                                        </td>
                                                                        <td className="text-center">{progressoAvaliacao.progresso_avaliacao.acerto}</td>
                                                                        <td className="text-center">{progressoAvaliacao.progresso_avaliacao.nota ? progressoAvaliacao.progresso_avaliacao.nota : '0'}</td>
                                                                        <td className="text-center small">{progressoAvaliacao.progresso_avaliacao.data_formatada}</td>
                                                                        <td className="text-center">
                                                                            {podeVerPdfProva() ? (
                                                                                <PDFDownloadLink
                                                                                    document={<GerarPDF data={progressoAvaliacao.progresso_avaliacao} titulo={progressoAvaliacao.progresso_avaliacao.nomeModulo} tipo="avaliacao" />}
                                                                                    fileName={`avaliacao_${progressoAvaliacao.progresso_avaliacao.nomeModulo}.pdf`}
                                                                                >
                                                                                    <button className="btn btn-sm btn-outline-primary text-nowrap">Ver Prova</button>
                                                                                </PDFDownloadLink>
                                                                            ) : (
                                                                                <Tippy content="Certificado expirado ou indisponível">
                                                                                    <button className="btn btn-sm btn-outline-secondary" disabled>
                                                                                        <i className="bi bi-lock-fill me-1"></i>Restrito
                                                                                    </button>
                                                                                </Tippy>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                }

                                                                {/* Histórico de provas anteriores (arquivadas) */}
                                                                {progressoAvaliacao.progresso_avaliacao_arquivada && progressoAvaliacao.progresso_avaliacao_arquivada.map((item, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="text-start fw-normal text-nowrap">
                                                                                <Tippy content={`${item.nomeModulo} - Avaliação`}>
                                                                                    <span>{truncateString(item.nomeModulo, 30)} - <b>Avaliação</b></span>
                                                                                </Tippy>
                                                                            </td>
                                                                            <td className="text-center">{item.acerto}</td>
                                                                            <td className="text-center">{item.nota ? item.nota : '0'}</td>
                                                                            <td className="text-center small">{item.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                {nivel === 'Administrador' || nivel === 'Moderador' ? (
                                                                                    <PDFDownloadLink
                                                                                        document={<GerarPDF data={item} titulo={item.nomeModulo} tipo="avaliacao" />}
                                                                                        fileName={`avaliacao_anterior_${item.nomeModulo}.pdf`}
                                                                                    >
                                                                                        <button className="btn btn-sm btn-outline-secondary">Ver Prova</button>
                                                                                    </PDFDownloadLink>
                                                                                ) : (
                                                                                    <Tippy content="Apenas administradores, gestores e Moderador podem visualizar provas anteriores">
                                                                                        <button className="btn btn-sm btn-outline-secondary" disabled>
                                                                                            <i className="bi bi-lock-fill me-1"></i>Restrito
                                                                                        </button>
                                                                                    </Tippy>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}

                                                                {/* Avaliação de Reação */}
                                                                {progressoAvaliacao.progresso_avaliacao_reacao &&
                                                                    <tr>
                                                                        <td className="text-start fw-normal text-nowrap">
                                                                            <Tippy content={`${progressoAvaliacao.progresso_avaliacao_reacao.nomeModulo} - Avaliação de Reação`}>
                                                                                <span>{truncateString(progressoAvaliacao.progresso_avaliacao_reacao.nomeModulo, 30)} - <b>Avaliação de Reação</b></span>
                                                                            </Tippy>
                                                                        </td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center small">{progressoAvaliacao.progresso_avaliacao_reacao.data_formatada}</td>
                                                                        <td className="text-center">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-success"
                                                                                onClick={() => {
                                                                                    setModalVerAvaliacaoReacao({
                                                                                        show: true,
                                                                                        data: progressoAvaliacao.progresso_avaliacao_reacao
                                                                                    });
                                                                                }}
                                                                            >
                                                                                Ver Avaliação
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                }

                                                                {/* Avaliação de Reação Híbrida */}
                                                                {progressoAvaliacao.progresso_avaliacao_reacao_hibrido &&
                                                                    <tr>
                                                                        <td className="text-start fw-normal text-nowrap">
                                                                            <Tippy content={`${progressoAvaliacao.progresso_avaliacao_reacao_hibrido.nomeModulo} - Avaliação de Reação Misto/Híbrido`}>
                                                                                <span>{truncateString(progressoAvaliacao.progresso_avaliacao_reacao_hibrido.nomeModulo, 30)} - <b>Avaliação de Reação</b></span>
                                                                            </Tippy>
                                                                        </td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center small">{progressoAvaliacao.progresso_avaliacao_reacao_hibrido.data_formatada}</td>
                                                                        <td className="text-center">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-success"
                                                                                onClick={() => {
                                                                                    setModalVerAvaliacaoReacao({
                                                                                        show: true,
                                                                                        data: progressoAvaliacao.progresso_avaliacao_reacao_hibrido
                                                                                    });
                                                                                }}
                                                                            >
                                                                                Ver Avaliação
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                }

                                                                {progressoAvaliacao.progresso_avaliacao_extra && progressoAvaliacao.progresso_avaliacao_extra.map((item, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="text-start fw-normal text-nowrap">
                                                                                <Tippy content={item.nomeAvaliacaoExtra}>
                                                                                    <span>{truncateString(item.nomeAvaliacaoExtra, 30)}</span>
                                                                                </Tippy>
                                                                            </td>
                                                                            <td className="text-center">{item.acerto}</td>
                                                                            <td className="text-center">{item.nota ? item.nota : '-'}</td>
                                                                            <td className="text-center">{item.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                {podeVerPdfProva() ? (
                                                                                    <PDFDownloadLink
                                                                                        document={<GerarPDF data={item.idAvaliacao} tipo="avaliacao_extra" titulo={item.nomeAvaliacaoExtra} />}
                                                                                        fileName={`avaliacao_extra_${item.nomeAvaliacaoExtra}.pdf`}
                                                                                    >
                                                                                        <button className="btn btn-sm btn-outline-info">Ver Prova</button>
                                                                                    </PDFDownloadLink>
                                                                                ) : (
                                                                                    <Tippy content="Acesso restrito: Seu certificado está próximo de expirar. É necessário refazer o curso para ter acesso novamente.">
                                                                                        <button className="btn btn-sm btn-outline-secondary" disabled>
                                                                                            <i className="bi bi-lock-fill me-1"></i>Restrito
                                                                                        </button>
                                                                                    </Tippy>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size='lg' show={showModalAtividadeExtra} onHide={() => setShowModalAtividadeExtra(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Provas extras e atividades</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <TableUsuariosProvas columns={columns} data={dataProvasExtras} titulo="Lista de provas" search={true} paging={false} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center">
                        <button type="button" className="btn btn-outline-dark px-5 py-2" onClick={() => setShowModalAtividadeExtra(false)}>Fechar</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalAtribuirNotas} onHide={() => setShowModalAtribuirNotas(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Atribuir Notas</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar usuário"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ maxHeight: 400, overflow: "auto" }}>
                            {filteredUsuarios.map(usuario => (
                                <div key={usuario.id} className="col-12 my-1 d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        {usuario.nome_completo}
                                    </div>
                                    <input
                                        type="number"
                                        className="form-control w-25"
                                        style={{ height: '35px' }}
                                        placeholder="Nota"
                                        value={notas[usuario.id] || ''}
                                        onChange={(e) => handleNotaChange(usuario.id, e.target.value)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center gap-2">
                        <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModalAtribuirNotas(false); setSearchTerm(null); setNotas(false) }}>Cancelar</button>
                        <button type="button" className="btn btn-primary text-white px-5 py-2" onClick={handleSubmitNotas}>Próximo</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalAlunosComNotas} onHide={() => setShowModalAlunosComNotas(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Enviar arquivo da prova</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex flex-column w-100">
                                        <div className="row" style={{ maxHeight: 400, overflow: "auto" }}>
                                            {alunosComNotas.map(usuario => (
                                                <div key={usuario.id} className="col-12 my-3 d-flex align-items-center">
                                                    <div className="flex-grow-1">
                                                        {usuario.nome_completo} <span className="badge bg-success fs-7">Nota: {notas[usuario.id]}</span>
                                                    </div>
                                                    <i className={`bi ${arquivos[usuario.id] ? 'bi-check-square-fill text-success' : 'bi-square'} me-3`}></i>
                                                    <span className="me-3" style={{ color: "rgb(185 185 185)" }}> | </span>
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <input
                                                            type="file"
                                                            id={`file-input-${usuario.id}`}
                                                            accept=".pdf,image/*"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleFileChange(e, usuario.id)}
                                                        />
                                                        <Tippy content="Escolher arquivo do computador">
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={() => handleUpload(usuario.id)}
                                                            >
                                                                <i className="bi bi-file-earmark-richtext"></i>
                                                            </button>
                                                        </Tippy>
                                                        <Tippy content="Tirar foto pelo celular">
                                                            <button
                                                                className="btn btn-primary d-none"
                                                                onClick={() => handleGenerateQrCode(usuario.id)}
                                                            >
                                                                <i className="bi bi-phone"></i>
                                                            </button>
                                                        </Tippy>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center gap-2">
                        <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModalAlunosComNotas(false); setShowModalAtribuirNotas(true); setTodosArquivosEnviados(false); setArquivos(false) }}>Voltar</button>
                        <button type="button" className="btn btn-primary text-white px-5 py-2" onClick={handleConcluir} disabled={!todosArquivosEnviados || loading}> {loading ? <div className="spinner-border fs-7" style={{ width: 20, height: 20, top: 2, position: 'relative' }} role="status"></div> : 'Finalizar'}</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="md" id="qrCodeModal" show={showModalQrCode} onHide={() => setShowModalQrCode(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">QR Code</span>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {qrCodeData && <QRCode value={qrCodeData} size={256} />}
                    <p className="mt-3">Escaneie este QR code para abrir o link no celular.</p>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center gap-2">
                        <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModalQrCode(false); setShowModalAlunosComNotas(true) }}>Voltar</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalFinalGrupo} onHide={() => setShowModalFinalGrupo(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Prova Final</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="h-100 bg-white rounded p-5 mt-3 text-center">
                        <div className="row">
                            <div className="col-12">
                                <i className="bi bi-check-circle text-success mb-3" style={{ fontSize: 60 }}></i>
                                <h1 className="text-success">Envios Concluidos!</h1>
                                <p className="lead mt-3">Conluido! Notas e arquivos foram enviados com sucesso.</p>
                                <Link className="btn btn-primary mt-4" onClick={() => setShowModalFinalGrupo(false)}>
                                    Voltar para a aula
                                </Link>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal para visualizar detalhes da avaliação de reação */}
            <ModalAvaliacaoReacao
                show={modalVerAvaliacaoReacao.show}
                data={modalVerAvaliacaoReacao.data}
                onHide={() => setModalVerAvaliacaoReacao({ show: false, data: null })}
            />

            {/* Modal de confirmação para deletar avaliação */}
            <Modal show={showModalDeletarAvaliacao} onHide={() => {
                setShowModalDeletarAvaliacao(false);
                setShowModalAvaliacao(true); // Volta para o modal anterior
            }}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar exclusão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja excluir esta avaliação? Esta ação não pode ser desfeita.
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-primary" onClick={() => {
                        setShowModalDeletarAvaliacao(false);
                        setShowModalAvaliacao(true); // Volta para o modal anterior
                    }}>
                        Cancelar
                    </button>
                    <button className="btn btn-danger" onClick={handleDeleteAvaliacao}>
                        Excluir
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal Nova Aula */}
            <Modal size="lg" show={showModalNovaAula} onHide={() => {
                setShowModalNovaAula(false);
                setTipoConteudoNova('arquivo');
                reset_Nova();
            }}>
                <form onSubmit={handleSubmit_Nova(onSubmitNovaAula)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-4 text-primary">Nova Aula</span>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="body">
                                        <div className="d-flex mb-5">
                                            <div className="d-flex flex-column w-100">
                                                <div className="row">

                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className='col-12 h-100 red-bg d-flex align-items-center justify-content-center rounded-3'>
                                                                <i className="bi bi-cloud-upload icon-large text-white"></i>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8 mt-3">
                                                            <div className="row">
                                                                <div className="col-12 col-md-12">
                                                                    <div className="mb-3">
                                                                        <input type="text" {...register_Nova("titulo", { required: true })} placeholder="Título da aula" className="form-control border-primary" />
                                                                        {errors_Nova.titulo && <span className='text-danger fs-7'>Título é obrigatório.</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="col-12 col-md-12">
                                                                    <div className="mb-3">
                                                                        <TextareaAutosize type="text" {...register_Nova("descricao", { required: true })} placeholder="Descrição da aula" className="form-control border-primary" />
                                                                        {errors_Nova.descricao && <span className='text-danger fs-7'>Descrição é obrigatória.</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Seletor de Tipo de Conteúdo - Não exibir para cursos presenciais */}
                                                    {dataInfoModulo[0]?.tipo_curso !== 'presencial' && (
                                                        <>
                                                            <div className="row mt-3">
                                                                <div className="col-12">
                                                                    <div className="mb-3">
                                                                        <label className="form-label text-primary fw-medium">Tipo de Conteúdo</label>
                                                                        <div className="btn-group w-100" role="group">
                                                                            <input
                                                                                type="radio"
                                                                                className="btn-check"
                                                                                name="tipoConteudoNova"
                                                                                id="tipoArquivoNova"
                                                                                value="arquivo"
                                                                                checked={tipoConteudoNova === 'arquivo'}
                                                                                onChange={(e) => setTipoConteudoNova(e.target.value)}
                                                                            />
                                                                            <label className="btn btn-outline-primary" htmlFor="tipoArquivoNova">
                                                                                <i className="bi bi-file-earmark-fill me-2"></i>
                                                                                Arquivo
                                                                            </label>

                                                                            <input
                                                                                type="radio"
                                                                                className="btn-check"
                                                                                name="tipoConteudoNova"
                                                                                id="tipoUrlExternaNova"
                                                                                value="url_externa"
                                                                                checked={tipoConteudoNova === 'url_externa'}
                                                                                onChange={(e) => setTipoConteudoNova(e.target.value)}
                                                                            />
                                                                            <label className="btn btn-outline-primary" htmlFor="tipoUrlExternaNova">
                                                                                <i className="bi bi-link-45deg me-2"></i>
                                                                                URL Externa
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Campos baseados no tipo de conteúdo */}
                                                            {tipoConteudoNova === 'arquivo' && (
                                                        <div className='row mt-3'>
                                                            <div className="col-6 col-md-4">
                                                                <div className="mb-3">
                                                                    <div className="card border-none">
                                                                        <p className='fs-7'>Arquivo da aula</p>
                                                                        <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                            <i className="bi bi-file-earmark-fill"></i>
                                                                        </h5>
                                                                        <div className="card-body d-flex justify-content-center bg-light">
                                                                            <p className="card-text fs-7">
                                                                                <label htmlFor="file_0_nova" className={`cursor-pointer ${file0SelectedNova ? 'text-success' : 'text-primary'}`}>Fazer Upload <i className="bi bi-cloud-upload"></i></label>
                                                                                <Controller
                                                                                    control={control_Nova}
                                                                                    name="file_0"
                                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                                        <input
                                                                                            id='file_0_nova'
                                                                                            type="file"
                                                                                            onBlur={onBlur}
                                                                                            ref={ref}
                                                                                            onChange={(e) => {
                                                                                                const files = e.target.files;
                                                                                                onChange(files);
                                                                                                if (files && files.length > 0) {
                                                                                                    setFile0SelectedNova(true);
                                                                                                } else {
                                                                                                    setFile0SelectedNova(false);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 col-md-4 border-start border-primary">
                                                                <div className="mb-3">
                                                                    <div className="card border-none">
                                                                        <p className='fs-7'>Arquivo Auxiliar 1</p>
                                                                        <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                            <i className="bi bi-file-earmark-fill"></i>
                                                                        </h5>
                                                                        <div className="card-body d-flex justify-content-center bg-light">
                                                                            <p className="card-text fs-7">
                                                                                <label htmlFor="file_1_nova" className={`cursor-pointer ${file1SelectedNova ? 'text-success' : 'text-primary'}`}>Fazer Upload  <i className="bi bi-cloud-upload"></i></label>
                                                                                <Controller
                                                                                    control={control_Nova}
                                                                                    name="file_1"
                                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                                        <input
                                                                                            id='file_1_nova'
                                                                                            type="file"
                                                                                            onBlur={onBlur}
                                                                                            ref={ref}
                                                                                            onChange={(e) => {
                                                                                                const files = e.target.files;
                                                                                                onChange(files);
                                                                                                if (files && files.length > 0) {
                                                                                                    setFile1SelectedNova(true);
                                                                                                } else {
                                                                                                    setFile1SelectedNova(false);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-4">
                                                                <div className="mb-3">
                                                                    <div className="card border-none">
                                                                        <p className='fs-7'>Arquivo Auxiliar 2</p>
                                                                        <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                            <i className="bi bi-file-earmark-fill"></i>
                                                                        </h5>
                                                                        <div className="card-body d-flex justify-content-center bg-light">
                                                                            <p className="card-text text-primary fs-7">
                                                                                <label htmlFor="file_2_nova" className={`cursor-pointer ${file2SelectedNova ? 'text-success' : 'text-primary'}`}>Fazer Upload  <i className="bi bi-cloud-upload"></i></label>

                                                                                <Controller
                                                                                    control={control_Nova}
                                                                                    name="file_2"
                                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                                        <input
                                                                                            id='file_2_nova'
                                                                                            type="file"
                                                                                            onBlur={onBlur}
                                                                                            ref={ref}
                                                                                            onChange={(e) => {
                                                                                                const files = e.target.files;
                                                                                                onChange(files);
                                                                                                if (files && files.length > 0) {
                                                                                                    setFile2SelectedNova(true);
                                                                                                } else {
                                                                                                    setFile2SelectedNova(false);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                                {errors_Nova.file_0 && <span className='text-danger fs-7'>Arquivo da aula é obrigatório.</span>}
                                                            </div>
                                                            )}

                                                            {tipoConteudoNova === 'url_externa' && (
                                                                <div className='row mt-3'>
                                                                    <div className="col-12">
                                                                        <div className="mb-3">
                                                                            <label className="form-label text-primary fw-medium">URL Externa</label>
                                                                            <input
                                                                                type="url"
                                                                                {...register_Nova("html_externo", {
                                                                                    required: tipoConteudoNova === 'url_externa',
                                                                                    pattern: {
                                                                                        value: /^https?:\/\/.+/,
                                                                                        message: "URL deve começar com http:// ou https://"
                                                                                    }
                                                                                })}
                                                                                placeholder="https://exemplo.com/conteudo ou https://www.youtube.com/watch?v=VIDEO_ID"
                                                                                className="form-control border-primary"
                                                                                onChange={(e) => {
                                                                                    const url = e.target.value;
                                                                                    if (url) {
                                                                                        // Se for YouTube, converte para embed
                                                                                        if (url.includes('youtube.com') || url.includes('youtu.be')) {
                                                                                            const embedUrl = validateYouTubeUrl(url);
                                                                                            setValue_Nova("html_externo", embedUrl);
                                                                                        } else {
                                                                                            setValue_Nova("html_externo", url);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            />
                                                                            {errors_Nova.html_externo && <span className='text-danger fs-7'>{errors_Nova.html_externo.message || 'URL externa é obrigatória.'}</span>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* Aviso para cursos presenciais */}
                                                    {dataInfoModulo[0]?.tipo_curso === 'presencial' && (
                                                        <div className="row mt-3">
                                                            <div className="col-12">
                                                                <div className="alert alert-info">
                                                                    <i className="bi bi-info-circle me-2"></i>
                                                                    Cursos presenciais não requerem upload de arquivos. O conteúdo será ministrado presencialmente.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Campo oculto para html_externo */}
                                                    <input
                                                        type="hidden"
                                                        {...register_Nova("html_externo")}
                                                    />

                                                </div>
                                                <div className="progress col-12 mt-4">
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${uploadAulaProgressNova}` }} aria-valuenow={uploadAulaProgressNova} aria-valuemin="0" aria-valuemax="100">{uploadAulaProgressNova}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center bg-light">
                        <button type="submit" className="btn btn-primary text-white px-5 py-2">Salvar</button>
                        <button type="button" className="btn btn-outline-primary text-primary px-5 py-2" onClick={() => setShowModalNovaAula(false)}> Cancelar </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default Aulas;